import { render, staticRenderFns } from "./BaseImageViewer.vue?vue&type=template&id=0d5f40dc&"
import script from "./BaseImageViewer.vue?vue&type=script&lang=js&"
export * from "./BaseImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./BaseImageViewer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports